import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MonthPickerDate } from '../month-picker/month-picker.component';
import * as moment from 'moment';

export interface RangeFilter {
  from: Date;
  to: Date;
}

@Component({
  selector: 'wsb-month-picker-range',
  templateUrl: './month-picker-range.component.html',
  styleUrls: ['./month-picker-range.component.scss'],
  standalone: false
})
export class MonthPickerRangeComponent implements OnInit {
  @Input() range: RangeFilter;
  @Output()
  rangeChange = new EventEmitter<RangeFilter>();

  formFilter: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.formFilter = this.fb.group({
      from: { year: this.range.from.getFullYear(), month: this.range.from.getMonth() + 1 },
      to: { year: this.range.to.getFullYear(), month: this.range.to.getMonth() + 1 }
    });

    // Emit initial values
    this.emitValues();

    this.formFilter.valueChanges.subscribe(() => {
      if (this.formFilter.valid) {
        this.emitValues();
      }
    });
  }

  private emitValues() {
    const fromMonthPickerDate = this.formFilter.controls.from.value;
    const toMonthPickerDate = this.formFilter.controls.to.value;

    this.rangeChange.emit({
      from: moment(new Date(fromMonthPickerDate.year, fromMonthPickerDate.month - 1))
        .startOf('month')
        .toDate(),
      to: moment(new Date(toMonthPickerDate.year, toMonthPickerDate.month - 1))
        .endOf('month')
        .toDate()
    });
  }

  getMinDateForToDateField(): MonthPickerDate {
    return Object.assign({}, this.formFilter.controls.from.value);
  }
}
